import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/team/pascal.jpg'
import _imports_1 from '@/assets/images/team/marie.jpg'
import _imports_2 from '@/assets/images/team/sebastian.jpg'
import _imports_3 from '@/assets/images/team/yuliia.jpg'
import _imports_4 from '@/assets/images/team/nicolas.jpg'
import _imports_5 from '@/assets/images/team/irma.jpg'
import _imports_6 from '@/assets/images/team/tianran.jpg'
import _imports_7 from '@/assets/images/team/felix.jpg'
import _imports_8 from '@/assets/images/team/johannes.jpg'
import _imports_9 from '@/assets/images/team/nico.jpg'
import _imports_10 from '@/assets/images/team/lennart.jpg'
import _imports_11 from '@/assets/images/team/carina.jpg'
import _imports_12 from '@/assets/images/team/alex.jpg'


const _withScopeId = n => (_pushScopeId("data-v-01254472"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Parrot Team"),
  /*#__PURE__*/_createElementVNode("div", { class: "card-container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
        /*#__PURE__*/_createElementVNode("h2", null, "Pascal"),
        /*#__PURE__*/_createElementVNode("div", null, "Product Owner")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_1,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
        /*#__PURE__*/_createElementVNode("h2", null, "Marie-Kristin"),
        /*#__PURE__*/_createElementVNode("div", null, "Product Owner")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_2,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
        /*#__PURE__*/_createElementVNode("h2", null, "Sebastian"),
        /*#__PURE__*/_createElementVNode("div", null, "Working student")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_3,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
        /*#__PURE__*/_createElementVNode("h2", null, "Yuliia"),
        /*#__PURE__*/_createElementVNode("div", null, "Working student")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_4,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
        /*#__PURE__*/_createElementVNode("h2", null, "Nicolas"),
        /*#__PURE__*/_createElementVNode("div", null, "Working student")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_5,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
        /*#__PURE__*/_createElementVNode("h2", null, "Irma"),
        /*#__PURE__*/_createElementVNode("div", null, "Working student")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_6,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
        /*#__PURE__*/_createElementVNode("h2", null, "Tianran"),
        /*#__PURE__*/_createElementVNode("div", null, "Working student")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_7,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
        /*#__PURE__*/_createElementVNode("h2", null, "Felix"),
        /*#__PURE__*/_createElementVNode("div", null, "Working student")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_8,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
        /*#__PURE__*/_createElementVNode("h2", null, "Johannes"),
        /*#__PURE__*/_createElementVNode("div", null, "Working student")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_9,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
        /*#__PURE__*/_createElementVNode("h2", null, "Nico"),
        /*#__PURE__*/_createElementVNode("div", null, "Working student")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_10,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
        /*#__PURE__*/_createElementVNode("h2", null, "Lennart"),
        /*#__PURE__*/_createElementVNode("div", null, "Working student")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_11,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
        /*#__PURE__*/_createElementVNode("h2", null, "Carina"),
        /*#__PURE__*/_createElementVNode("div", null, "Working student")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_12,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("div", { class: "text-box" }, [
        /*#__PURE__*/_createElementVNode("h2", null, "Alex"),
        /*#__PURE__*/_createElementVNode("div", null, "Working student")
      ])
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EndLayoutComponent = _resolveComponent("EndLayoutComponent")!

  return (_openBlock(), _createBlock(_component_EndLayoutComponent, null, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}